<div class="boards-container">
  <div class="boards-header">
    <div class="row">
      <div class="col-md-6">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="searchText"
          (ngModelChange)="filterSchedulingTeams()"
          placeholder="Search scheduling teams..."
          aria-label="Search scheduling teams"
        />
      </div>
      <div class="col-md-6 text-right">
        <button *ngIf="canEdit" class="btn btn-primary" (click)="openAddModal()">
          <i class="fa fa-plus"></i> Add Scheduling Team
        </button>
      </div>
    </div>
  </div>

  <div class="boards-list" *ngIf="!isLoading && filteredSchedulingTeams.length > 0">
    <div class="board-card" *ngFor="let schedulingTeam of filteredSchedulingTeams">
      <!-- Scheduling Team Header (Clickable) -->
      <div class="board-header" (click)="toggleSchedulingTeamExpansion(schedulingTeam.id!)">
        <div class="board-header-left">
          <i
            class="fa"
            [ngClass]="
              isSchedulingTeamExpanded(schedulingTeam.id!) ? 'fa-chevron-down' : 'fa-chevron-right'
            "
          ></i>
          <span class="board-name" [innerHTML]="highlightText(schedulingTeam.name)"></span>
          <span class="board-stats">
            <span class="stat-badge driver-badge">
              <i class="fa fa-user"></i> {{ schedulingTeam.drivers.length }} Driver{{
                schedulingTeam.drivers.length !== 1 ? "s" : ""
              }}
            </span>
          </span>
        </div>
        <div class="board-header-right" *ngIf="canEdit">
          <button
            class="btn-icon"
            (click)="openEditModal(schedulingTeam); $event.stopPropagation()"
            title="Edit Scheduling Team"
          >
            <i class="fa fa-pencil"></i>
          </button>
          <button
            class="btn-icon btn-danger"
            (click)="deleteSchedulingTeam(schedulingTeam); $event.stopPropagation()"
            title="Delete Scheduling Team"
          >
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>

      <!-- Scheduling Team Body (Expandable) -->
      <div class="board-body" *ngIf="isSchedulingTeamExpanded(schedulingTeam.id!)">
        <!-- Contacts Section -->
        <div
          class="board-section"
          *ngIf="schedulingTeam.contacts && schedulingTeam.contacts.length > 0"
        >
          <h5>Contacts</h5>
          <div class="contacts-list">
            <div class="contact-row" *ngFor="let contact of schedulingTeam.contacts">
              <div class="contact-name">
                <strong>{{ contact.name }}</strong>
                <span class="contact-role" *ngIf="contact.role">({{ contact.role }})</span>
              </div>
              <div class="contact-email" *ngIf="contact.email">
                <i class="fa fa-envelope"></i>
                <span>Email: {{ contact.email }}</span>
              </div>
              <div class="contact-phone" *ngIf="contact.phone">
                <i class="fa fa-phone"></i>
                <span>Phone: {{ contact.phone | phoneNumber }}</span>
              </div>
              <div class="contact-do-not-contact" *ngIf="contact.doNotContact">
                ⚠️ Do Not Contact
              </div>
            </div>
          </div>
        </div>

        <!-- Boards Section -->
        <div
          class="board-section"
          *ngIf="schedulingTeam.boards && schedulingTeam.boards.length > 0"
        >
          <h5>Boards</h5>
          <div class="board-options-list">
            <div class="board-option-item" *ngFor="let board of schedulingTeam.boards">
              <i class="fa fa-tag"></i>
              <span [innerHTML]="highlightText(board.name)"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="loading-spinner" *ngIf="isLoading">
    <i class="fa fa-spinner fa-spin"></i> Loading scheduling teams...
  </div>

  <div class="no-boards" *ngIf="!isLoading && filteredSchedulingTeams.length === 0">
    <i class="fa fa-clipboard"></i>
    <p>No scheduling teams found</p>
  </div>

  <!-- Driver Changes Audit Log Section -->
  <div class="audit-section" *ngIf="!isLoading && filteredSchedulingTeams.length > 0">
    <div class="audit-header" (click)="toggleAuditLogExpansion()">
      <div class="audit-header-left">
        <i class="fa" [ngClass]="isAuditLogExpanded ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
        <span class="audit-title">Driver Assignment Changes</span>
        <span class="audit-count" *ngIf="filteredAuditLogs.length > 0">
          ({{ filteredAuditLogs.length }} of {{ auditLogs.length }} changes)
        </span>
      </div>
      <div class="audit-header-right" *ngIf="isAuditLogExpanded" (click)="$event.stopPropagation()">
        <button
          class="btn btn-sm btn-outline-primary"
          (click)="exportAuditLogsToCSV()"
          title="Export to CSV"
        >
          <i class="fa fa-download"></i> Export CSV
        </button>
      </div>
    </div>

    <div class="audit-body" *ngIf="isAuditLogExpanded">
      <div class="audit-loading" *ngIf="isLoadingAuditLogs">
        <i class="fa fa-spinner fa-spin"></i> Loading driver changes...
      </div>

      <!-- Audit Log Filters -->
      <div class="audit-filters" *ngIf="!isLoadingAuditLogs && auditLogs.length > 0">
        <div class="row">
          <div class="col-md-3">
            <label class="filter-label">Driver</label>
            <input
              type="text"
              class="form-control form-control-sm"
              [(ngModel)]="auditFilters.driverName"
              (ngModelChange)="filterAuditLogs()"
              placeholder="Filter by driver name"
              aria-label="Filter by driver name"
            />
          </div>
          <div class="col-md-2">
            <label class="filter-label">Action</label>
            <select
              class="form-control form-control-sm"
              [(ngModel)]="auditFilters.action"
              (ngModelChange)="filterAuditLogs()"
              aria-label="Filter by action"
            >
              <option value="">All Actions</option>
              <option value="Assigned">Assigned</option>
              <option value="Removed">Removed</option>
              <option value="Updated">Updated</option>
            </select>
          </div>
          <div class="col-md-2">
            <label class="filter-label">From Date</label>
            <input
              type="date"
              class="form-control form-control-sm"
              [(ngModel)]="auditFilters.fromDate"
              (ngModelChange)="filterAuditLogs()"
              aria-label="Audit filter from date"
            />
          </div>
          <div class="col-md-2">
            <label class="filter-label">To Date</label>
            <input
              type="date"
              class="form-control form-control-sm"
              [(ngModel)]="auditFilters.toDate"
              (ngModelChange)="filterAuditLogs()"
              aria-label="Audit filter to date"
            />
          </div>
          <div class="col-md-3">
            <label class="filter-label">Scheduling Team</label>
            <input
              type="text"
              class="form-control form-control-sm"
              [(ngModel)]="auditFilters.schedulingTeam"
              (ngModelChange)="filterAuditLogs()"
              placeholder="Filter by team name"
              aria-label="Filter by scheduling team"
            />
          </div>
        </div>
        <div class="filter-actions">
          <button class="btn btn-sm btn-outline-secondary" (click)="clearAuditFilters()">
            <i class="fa fa-times"></i> Clear Filters
          </button>
        </div>
      </div>

      <div class="audit-logs-list" *ngIf="!isLoadingAuditLogs && filteredAuditLogs.length > 0">
        <div class="audit-log-item" *ngFor="let log of filteredAuditLogs">
          <div class="log-icon">
            <i
              class="fa"
              [ngClass]="{
                'fa-user-plus text-success': log.action === 'Assigned',
                'fa-user-minus text-danger': log.action === 'Removed',
                'fa-edit text-warning': log.action === 'Updated',
              }"
            ></i>
          </div>
          <div class="log-content">
            <div class="log-main">
              <strong>{{ log.driverName || "Unknown Driver" }}</strong>
              <span class="log-action">{{ log.action.toLowerCase() }}</span>
              <span *ngIf="log.action !== 'Removed'">
                to <strong>{{ log.schedulingTeamName }}</strong>
                <span *ngIf="log.boardName"> - {{ log.boardName }}</span>
                <span *ngIf="log.billToClientName"> ({{ log.billToClientName }})</span>
              </span>
              <span *ngIf="log.action === 'Removed'">
                from <strong>{{ log.schedulingTeamName }}</strong>
              </span>
            </div>
            <div class="log-meta">
              <span class="log-date">{{ formatDate(log.dateCreatedUtc) }}</span>
              <span class="log-user" *ngIf="log.userName"> by {{ log.userName }}</span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="no-audit-logs"
        *ngIf="!isLoadingAuditLogs && auditLogs.length > 0 && filteredAuditLogs.length === 0"
      >
        <i class="fa fa-filter"></i>
        <p>No driver assignment changes match the current filters</p>
      </div>

      <div class="no-audit-logs" *ngIf="!isLoadingAuditLogs && auditLogs.length === 0">
        <i class="fa fa-history"></i>
        <p>No recent driver assignment changes found</p>
      </div>
    </div>
  </div>
</div>

<!-- Add Scheduling Team Modal -->
<p-dialog
  [(visible)]="showAddModal"
  [header]="'Add Scheduling Team'"
  [modal]="true"
  [style]="{ width: '700px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="modal-body">
    <div class="form-group">
      <label>Scheduling Team Name <span class="text-danger">*</span></label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="newSchedulingTeam.name"
        placeholder="Enter scheduling team name"
        aria-label="Scheduling team name"
      />
    </div>

    <div class="form-group">
      <label>Contacts</label>
      <div class="items-list">
        <div
          *ngFor="let contact of selectedContacts; let i = index; trackBy: trackByIndex"
          class="contact-form-row"
        >
          <div class="contact-form-vertical">
            <div class="form-field-full">
              <label class="field-label">Name <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="selectedContacts[i].name"
                placeholder="Enter contact name"
                aria-label="Contact name"
              />
            </div>
            <div class="form-field-full">
              <label class="field-label">Email</label>
              <input
                type="email"
                class="form-control"
                [(ngModel)]="selectedContacts[i].email"
                placeholder="Enter email address"
                aria-label="Contact email"
              />
            </div>
            <div class="form-field-full">
              <label class="field-label">Phone</label>
              <input
                type="tel"
                class="form-control"
                [(ngModel)]="selectedContacts[i].phone"
                placeholder="Enter phone number"
                aria-label="Contact phone"
              />
            </div>
            <div class="form-field-full">
              <label class="field-label">Role</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="selectedContacts[i].role"
                placeholder="Enter role/title"
                aria-label="Contact role"
              />
            </div>
            <div class="form-field-full checkbox-field">
              <label class="checkbox-label">
                <input type="checkbox" [(ngModel)]="selectedContacts[i].doNotContact" aria-label="Do not contact" />
                Do Not Contact
              </label>
            </div>
          </div>
          <button
            class="btn btn-sm btn-remove"
            (click)="removeNewContact(i)"
            title="Remove Contact"
          >
            <i class="fa fa-minus"></i>
          </button>
        </div>
        <button class="btn btn-secondary btn-add" (click)="addNewContact()">
          <i class="fa fa-plus"></i> Add Contact
        </button>
      </div>
    </div>

    <div class="form-group">
      <label>Boards</label>
      <div class="items-list">
        <div
          *ngFor="let boardName of selectedBoardNames; let i = index; trackBy: trackByIndex"
          class="item-row"
        >
          <input
            type="text"
            class="form-control"
            [(ngModel)]="selectedBoardNames[i]"
            placeholder="Enter board name"
            aria-label="Board name"
          />
          <button class="btn btn-sm btn-remove" (click)="removeNewBoard(i)">
            <i class="fa fa-minus"></i>
          </button>
        </div>
        <button class="btn btn-secondary btn-add" (click)="addNewBoard()">
          <i class="fa fa-plus"></i> Add Board
        </button>
      </div>
    </div>
  </div>

  <p-footer>
    <div class="button-group">
      <button class="btn btn-secondary" (click)="closeAddModal()">Cancel</button>
      <button class="btn btn-primary" (click)="createSchedulingTeam()">
        Create Scheduling Team
      </button>
    </div>
  </p-footer>
</p-dialog>

<!-- Edit Scheduling Team Modal -->
<p-dialog
  [(visible)]="showEditModal"
  [header]="'Edit Scheduling Team'"
  [modal]="true"
  [style]="{ width: '700px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="modal-body" *ngIf="editingSchedulingTeam">
    <div class="form-group">
      <label>Scheduling Team Name <span class="text-danger">*</span></label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="editingSchedulingTeam.name"
        placeholder="Enter scheduling team name"
        aria-label="Scheduling team name"
      />
    </div>

    <div class="form-group">
      <label>Contacts</label>
      <div class="items-list">
        <div
          *ngFor="let contact of editSelectedContacts; let i = index; trackBy: trackByIndex"
          class="contact-form-row"
        >
          <div class="contact-form-vertical">
            <div class="form-field-full">
              <label class="field-label">Name <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="editSelectedContacts[i].name"
                placeholder="Enter contact name"
                aria-label="Contact name"
              />
            </div>
            <div class="form-field-full">
              <label class="field-label">Email</label>
              <input
                type="email"
                class="form-control"
                [(ngModel)]="editSelectedContacts[i].email"
                placeholder="Enter email address"
                aria-label="Contact email"
              />
            </div>
            <div class="form-row-inline">
              <div class="form-field-half">
                <label class="field-label">Phone</label>
                <input
                  type="tel"
                  class="form-control"
                  [(ngModel)]="editSelectedContacts[i].phone"
                  placeholder="Enter phone number"
                  aria-label="Contact phone"
                />
              </div>
              <div class="form-field-half">
                <label class="field-label">Role</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="editSelectedContacts[i].role"
                  placeholder="Enter role/title"
                  aria-label="Contact role"
                />
              </div>
            </div>
            <div class="form-field-full checkbox-field">
              <label class="checkbox-label">
                <input type="checkbox" [(ngModel)]="editSelectedContacts[i].doNotContact" aria-label="Do not contact" />
                Do Not Contact
              </label>
            </div>
          </div>
          <button
            class="btn btn-sm btn-remove"
            (click)="removeEditContact(i)"
            title="Remove Contact"
          >
            <i class="fa fa-minus"></i>
          </button>
        </div>
        <button class="btn btn-secondary btn-add" (click)="addEditContact()">
          <i class="fa fa-plus"></i> Add Contact
        </button>
      </div>
    </div>

    <div class="form-group">
      <label>Boards</label>
      <div class="items-list">
        <div
          *ngFor="let boardName of editSelectedBoardNames; let i = index; trackBy: trackByIndex"
          class="item-row"
        >
          <input
            type="text"
            class="form-control"
            [(ngModel)]="editSelectedBoardNames[i]"
            placeholder="Enter board name"
            aria-label="Board name"
          />
          <button class="btn btn-sm btn-remove" (click)="removeEditBoard(i)">
            <i class="fa fa-minus"></i>
          </button>
        </div>
        <button class="btn btn-secondary btn-add" (click)="addEditBoard()">
          <i class="fa fa-plus"></i> Add Board
        </button>
      </div>
    </div>
  </div>

  <p-footer>
    <div class="button-group">
      <button class="btn btn-secondary" (click)="closeEditModal()">Cancel</button>
      <button class="btn btn-primary" (click)="updateSchedulingTeam()">
        Update Scheduling Team
      </button>
    </div>
  </p-footer>
</p-dialog>
